<ng-template [ngIf]="stageDetailsForm" [ngIfElse]="init">
  <div class="bg-white p-xl-5 p-2">
    <div class="border-bottom border-gray">
      <button type="button" class="btn btn-icons float-start" aria-label="Close" (click)="cancel()">
        <span aria-hidden="true">&times;</span>
      </button>
      <h3 class="text-end text-secondary pb-2" *ngIf="isModificationMode">Étape du {{ stage.beginDate | date }} au {{ stage.endDate | date }}</h3>
      <h3 class="text-end text-secondary pb-2" *ngIf="!isModificationMode">Création d'une étape</h3>
    </div>
    <form [formGroup]="stageDetailsForm" (ngSubmit)="onSubmit()">
      <div class="modal-body">
        <!-- Nature / Type -->
        <div class="row">
          <div class="mb-3 text-secondary col-12">
            <small class="form-text text-secondary">Les champs actifs marqués d'un <em class="text-danger">*</em> sont obligatoires.</small>
            <small *ngIf="submitted && stageDetailsForm.controls?.orientationBeginDate?.errors?.required" class="form-text text-danger">
              Il est impossible de créer une étape pour un bénéficiaire qui ne possède pas de date de début d'orientation.
            </small>
          </div>
          <div class="mb-3 col-12 col-lg-6">
            <label class="text-secondary required">Nature</label>
            <select class="form-select" formControlName="stageNature" [class.is-invalid]="submitted && stageDetailsForm.controls.stageNature.invalid">
              <option *ngIf="!stageDetailsForm.value.stageNature" [ngValue]="" selected hidden></option>
              <option *ngFor="let stageNature of stageNatureTypes | uniqueNature" [ngValue]="stageNature">
                {{ stageNature }}
              </option>
            </select>
            <small *ngIf="submitted && stageDetailsForm.controls?.stageNature?.errors?.required" class="form-text text-danger">
              La nature de l'étape est requis.
            </small>
          </div>
          <div class="mb-3 col-12 col-lg-6">
            <label class="text-secondary required">Type</label>
            <select class="form-select" formControlName="stageType" [class.is-invalid]="submitted && stageDetailsForm.controls.stageType.invalid">
              <option *ngIf="!stageDetailsForm.value.stageType" [ngValue]="" selected hidden></option>
              <option
                *ngFor="let stageType of stageNatureTypes | filterStageType: { stageNatureType: stageDetailsForm.controls?.stageNature?.value }"
                [ngValue]="stageType.id"
                [disabled]="stageType.deprecated"
              >
                {{ stageType.type }}
              </option>
            </select>
            <small *ngIf="submitted && stageDetailsForm.controls?.stageType?.errors?.required" class="form-text text-danger">
              Le type de l'étape est requis.
            </small>
          </div>
        </div>

        <!-- Libellé / Sesion -->
        <div class="row">
          <div class="mb-3 col-12 col-lg-6" *ngIf="isNatureFse">
            <label class="text-secondary required">Libellé</label>

            <ng-select
              formControlName="label"
              [items]="labels"
              bindLabel="label"
              bindValue="id"
              notFoundText=""
              [clearable]="false"
              (change)="handleLabelChange($event)"
              [closeOnSelect]="true"
              [class.is-invalid]="submitted && stageDetailsForm.controls.label.invalid"
            >
              <ng-template ng-option-tmp let-item="item" let-index="index">
                <p class="mb-0">{{ item.label }}</p>
                <small class="text-muted">{{ item.structure.label }}</small>
              </ng-template>
            </ng-select>

            <small *ngIf="submitted && stageDetailsForm.controls?.label?.errors?.required" class="form-text text-danger">
              Le Libellé est requis.
            </small>
          </div>
          <div class="mb-3 col-12 col-lg-6" *ngIf="!isNatureFse">
            <label class="text-secondary">Libellé</label>
            <input formControlName="label" class="form-control" />
          </div>

          <div class="mb-3 col-12 col-lg-6">
            <label class="text-secondary required">Session</label>
            <select class="form-select" formControlName="session" [class.is-invalid]="submitted && stageDetailsForm.controls.session.invalid">
              <option *ngIf="!stageDetailsForm.value.session" [ngValue]="" selected hidden></option>
              <option *ngFor="let session of sessions" [ngValue]="session.id">
                {{ session.label }}
              </option>
            </select>
            <small *ngIf="sessions && submitted && stageDetailsForm.controls?.session?.errors?.required" class="form-text text-danger">
              La session est requise.
            </small>
          </div>
        </div>

        <!-- Dates -->
        <div class="row">
          <div class="mb-3 col-12 col-lg-6">
            <label class="text-secondary required">Date de début</label>
            <app-datepicker
              id="fieldBeginDate"
              formControlName="beginDate"
              [invalid]="submitted && (stageDetailsForm.errors?.datesOrder || stageDetailsForm.controls?.beginDate?.invalid)"
            ></app-datepicker>
            <small *ngIf="submitted && stageDetailsForm.errors?.datesOrder" class="form-text text-danger"
              >La date de début est incohérente avec la date de fin.</small
            >
            <small *ngIf="submitted && stageDetailsForm.errors?.datesOrderValue" class="form-text text-danger"
              >La date de début doit être supérieure à la date de début d'orientation.</small
            >
            <small
              *ngIf="submitted && !stageDetailsForm.controls?.beginDate?.errors?.required && stageDetailsForm.controls?.beginDate?.errors?.dateFormat"
              class="form-text text-danger"
              >La date de début est invalide.</small
            >
            <small *ngIf="submitted && stageDetailsForm.controls?.beginDate?.errors?.required" class="form-text text-danger"
              >La date de début est requise.</small
            >
          </div>
          <div class="mb-3 col-12 col-lg-6">
            <label class="text-secondary required">Date de fin</label>
            <app-datepicker
              id="fieldEndDate"
              formControlName="endDate"
              [invalid]="submitted && (stageDetailsForm.errors?.datesOrder || stageDetailsForm.controls?.endDate?.invalid)"
            ></app-datepicker>
            <small *ngIf="submitted && stageDetailsForm.errors?.datesOrder" class="form-text text-danger"
              >La date de fin est incohérente avec la date de début.</small
            >
            <small
              *ngIf="submitted && !stageDetailsForm.controls?.endDate?.errors?.required && stageDetailsForm.controls?.endDate?.errors?.dateFormat"
              class="form-text text-danger"
              >La date de fin est invalide.</small
            >
            <small *ngIf="submitted && stageDetailsForm.controls?.endDate?.errors?.required" class="form-text text-danger"
              >La date de fin est requise.</small
            >
          </div>

          <!-- Organisme / durée -->
          <div class="mb-3 col-12 col-lg-6">
            <label class="text-secondary">Organisme</label>
            <input formControlName="organization" class="form-control" />
          </div>
          <div class="mb-3 col-12 col-lg-6">
            <label class="text-secondary">Durée (min)</label>
            <input appInputNumbersOnly formControlName="duration" class="form-control" maxLength="6" />
          </div>

          <!--Motif de fin -  Etat -->
          <div class="mb-3 col-12 col-lg-6">
            <label class="text-secondary required">État</label>
            <select class="form-select" formControlName="stageState" [class.is-invalid]="submitted && stageDetailsForm.controls.stageState.invalid">
              <option
                *ngFor="let stageState of stageStates | keyvalue: StringUtils.stringAscOrder"
                [ngValue]="stageState.key"
                [hidden]="hiddenStates.includes(stageState.value) || ['Canceled', 'AbsenceJustified', 'AbsenceNotJustified'].includes(stageState.key)"
              >
                {{ stageState.value }}
              </option>
            </select>
            <small *ngIf="submitted && stageDetailsForm.controls?.stageState?.errors?.required" class="form-text text-danger"
              >L'état de l'étape est requis.</small
            >
          </div>

          <!--Commentaire -->
          <div class="mb-3 col-12">
            <label class="text-secondary">Commentaires</label>
            <textarea formControlName="comment" class="form-control"></textarea>
          </div>
        </div>
      </div>
      <!-- Boutons actions -->
      <div class="row px-3">
        <div class="col-3 d-md-none d-lg-block col-lg-3 mb-1" *ngIf="!isModificationMode"></div>
        <div class="d-grid col-3 col-md-6 col-lg-3 mb-1" ngbTooltip="Générer un questionnaire">
          <button
            class="btn btn-primary d-flex justify-content-center"
            type="button"
            (click)="generateSurvey()"
            [disabled]="!canGenerate"
            *appOnlyGroups="['ADMIN', 'STRUCTURE', 'DIRECTION+']"
          >
            <fa-icon icon="save"></fa-icon>
            <span class="ms-3 d-none d-md-block">Générer</span>
          </button>
        </div>
        <div
          class="d-grid col-3 col-md-6 col-lg-3 mb-1"
          *ngIf="
            isModificationMode &&
            (!user.groups.includes('STRUCTURE') ||
              stageDetailsForm.controls?.beginDate.value >= this.dateService.getCurrent() ||
              !isNatureFse ||
              !stage.sessionId)
          "
        >
          <button
            class="btn btn-primary d-flex justify-content-center"
            type="button"
            (click)="deleteStage()"
            *appOnlyGroups="['ADMIN', 'STRUCTURE', 'DIRECTION+']"
          >
            <fa-icon icon="trash"></fa-icon>
            <span class="ms-3 d-none d-md-block">Supprimer</span>
          </button>
        </div>
        <div class="d-grid col-3 col-md-6 col-lg-3 mb-1">
          <button class="btn btn-primary d-flex justify-content-center" type="button" (click)="cancel()">
            <fa-icon icon="ban"></fa-icon>
            <span class="ms-3 d-none d-md-block">Annuler</span>
          </button>
        </div>
        <div class="d-grid col-3 col-md-6 col-lg-3 mb-1">
          <button
            *appOnlyGroups="['ADMIN', 'STRUCTURE', 'DIRECTION+']"
            class="btn btn-primary d-flex justify-content-center"
            type="submit"
            [disabled]="!hasStructure"
          >
            <fa-icon icon="save"></fa-icon>
            <span class="ms-3 d-none d-md-block">Sauvegarder</span>
          </button>
        </div>
      </div>
    </form>
  </div>
</ng-template>
<ng-template #init>
  <div class="bg-white p-xl-5 p-2"></div>
</ng-template>
